/**
 * 业务系统列定义.
 */

export default {
  code: 200,
  data: {
    items: [
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-edit',
        cssType: '',
        name: '编辑',
        showExp: '{{!!data.urlItemsDef && data.editRowMenu}}',
        param: {
          methodName: 'handleEditRowMenu',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-details',
        cssType: '',
        name: '查看冷链记录',
        showExp: '{{!!data.menuCheckLLRecord}}',
        param: {
          methodName: 'handleMenuCheckLLRecord',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-spfanwei',
        cssType: '',
        name: '关联商品(SKU)',
        showExp: '{{!!data.SKUShow}}',
        param: {
          methodName: 'handleMenuClickSKURow',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-charuhang',
        cssType: '',
        name: '插入行',
        showExp: '{{!!data.menuInsertShow}}',
        param: {
          methodName: 'handleMenuClickOfRowInsertRow',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-chaifen',
        cssType: '',
        name: '拆分',
        showExp: '{{!!data.menuSplitShow}}',
        param: {
          methodName: 'handleMenuClickOfRowSplitRow',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-copy',
        cssType: '',
        name: '复制',
        showExp: '{{!!data.menuCopyAddShow}}',
        param: {
          methodName: 'handleToolbarMenuAdd',
        },
      },
      {
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-edit',
        cssType: '',
        name: '刷新映射关系',
        showExp: '{{!!data.menuRefreshMapShow}}',
        param: {
          methodName: 'handleRefreshMapSingle',
        },
      },
      {
        style: 'error',
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-delete',
        cssType: '',
        name: '删除',
        showExp: '{{!!data.menuDeleteShow}}',
        param: {
          methodName: 'handleDeleteRowMenu',
        },
        enableExp: '',
      },
      {
        style: 'error',
        type: 'method',
        children: null,
        icon: 'ivu-icon-icon-pg-remove',
        cssType: '',
        name: '移除',
        showExp: '{{!!data.menuRemoveShow}}',
        param: {
          methodName: 'handleDeleteRowMenu',
        },
        enableExp: '',
      },
    ],
  },
  msg: 'string',
  success: false,
}
